(function () {

    "use strict";

    angular
        .module('harriApp')
        .component('brandJobSelectorComponent', {
            controller: BrandJobSelectorController,
            bindings: {
                brandId: "<",
                ngModel: "=?",
                onJobSelected: "&",
                canNavigateToGps: "<"
            },
            templateUrl: '../hmodules/talent-pool/components/brand-job-selector/brand-job-selector.component.html'
        });

    BrandJobSelectorController.$inject = ['$scope', '$q', 'hUser'];

    function BrandJobSelectorController($scope, $q, hUser) {
        var self = this;

        self.NAVIGATION_TYPES = {};
        self.NAVIGATION_TYPES.ROOT = "ROOT";
        self.NAVIGATION_TYPES.PARENT = "PARENT";
        self.NAVIGATION_TYPES.LEFT = "LEFT";
        self.NAVIGATION_TYPES.RIGHT = "RIGHT";

        self.levels = {};

        var selectedBrand;
        self.selectedJob = null;

        var resetStatus = function () {
            delete self.searchString;
            delete self.ngModel;
            delete self.selectedJob;
            selectedBrand = null;
        };

        self.selectJob = function (job, brand) {
            self.ngModel = self.selectedJob = job;
            selectedBrand = brand;
            var data = {
                brand: selectedBrand,
                job: self.selectedJob
            };
            self.onJobSelected && self.onJobSelected({data: data});
        };

        self.isEnterpriseOrChildBrand = function (brandType) {
            return brandType?.indexOf("GP") === -1
        };

        self.filterBrands = function (brand) {
            if (!self.searchString) {
                return brand;
            } else {
                var jobIndex = -1;

                for (var i in brand.jobs) {
                    var job = brand.jobs[i];

                    if (job.alias_position && job.alias_position.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1
                        || job.position.name.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1) {
                        jobIndex = parseInt(i);
                    }
                }

                if (jobIndex !== -1) {
                    return brand;
                }
            }
        };

        self.onNavigationClick = function (type) {

            var canNavigateValue = self.canNavigate(type);

            if (!canNavigateValue) {
                return;
            }

            resetStatus();

            for (var i in self.levels[self.activeBrand.parent_type][self.activeBrand.parent_id].children[self.activeBrand.brand_id].brands) {
                self.levels[self.activeBrand.parent_type][self.activeBrand.parent_id].children[self.activeBrand.brand_id].brands[i].expandJobs = false;
            }

            var includeJobs;

            switch (type) {
                case self.NAVIGATION_TYPES.ROOT:

                    var entryBrand = hUser.getEntryMode();

                    includeJobs = self.isEnterpriseOrChildBrand(entryBrand.brand_type);

                    self.loading = true;
                    expandBrand(entryBrand.brand_id, false, true)
                        .then(function () {
                            self.loading = false;
                        });

                    break;
                case self.NAVIGATION_TYPES.PARENT:

                    includeJobs = self.isEnterpriseOrChildBrand(self.activeBrand.parent_type);

                    self.loading = true;
                    expandBrand(self.activeBrand.parent_id, includeJobs, true)
                        .then(function () {
                            self.loading = false;
                        });

                    break;
                case self.NAVIGATION_TYPES.LEFT:

                    var brandId = canNavigateValue;

                    includeJobs = self.isEnterpriseOrChildBrand(self.activeBrand.brand_type);

                    self.loading = true;
                    expandBrand(brandId, includeJobs, false)
                        .then(function () {
                            self.loading = false;
                        });

                    break;
                case self.NAVIGATION_TYPES.RIGHT:

                    var brandId = canNavigateValue;

                    includeJobs = self.isEnterpriseOrChildBrand(self.activeBrand.brand_type);

                    self.loading = true;
                    expandBrand(brandId, includeJobs, false)
                        .then(function () {
                            self.loading = false;
                        });

                    break;
            }
        };

        self.onExpandBtnClicked = function (brand) {

            resetStatus();

            if (self.isEnterpriseOrChildBrand(self.activeBrand.brand_type)) {

                toggleExpandJobsForBrand(brand);

            } else {

                var includeJobs = self.isEnterpriseOrChildBrand(brand.type);

                self.loading = true;

                expandBrand(brand.id, includeJobs, true)
                    .then(function () {
                        self.loading = false;
                    });

            }

        };

        var expandBrand = function (brandId, includeJobs, includeParent) {

            /*
            * includeParent only works when the brandId doesnt equal to the entry brandId,
            * if so, the root brand in the response will be the entry brand not the parent brand.
            * */

            var defer = $q.defer();

            var activeBrand;

            stupid_label_to_break_nested_loop:
                for (var i in self.levels) {
                    for (var j in self.levels[i]) {
                        if (self.levels[i][j].children[brandId] && self.levels[i][j].children[brandId].brands) {
                            activeBrand = {
                                brand_type: self.levels[i][j].children[brandId].type,
                                brand_name: self.levels[i][j].children[brandId].name,
                                brand_id: self.levels[i][j].children[brandId].id,
                                parent_type: self.levels[i][j].type,
                                parent_id: self.levels[i][j].id,
                            };
                            break stupid_label_to_break_nested_loop;
                        }
                    }
                }

            if (!activeBrand) {

                BrandAPI.getBrandsTree(brandId, includeJobs, includeParent, null, true)
                    .then(function (brandsTree) {
                        if (brandId !== brandsTree.id && includeParent) {
                            // include parent = true and root brand tree equals the parent brand
                            handleParentRoot(brandId, brandsTree);
                        } else if (!includeParent) {
                            // don't include parent and root brand tree equals the active brand
                            handleActiveBrandRoot(brandsTree);
                        } else if (includeParent) {
                            // special case: include parent and root brand tree is the active brand, happens when the active brand is the entry brand
                            handleEntryBrandRoot(brandsTree);
                        }
                        defer.resolve();
                    }).finally(function () {
                    $scope.$digest();
                });

            } else {
                angular.extend(self.activeBrand, activeBrand);
                defer.resolve();
            }

            return defer.promise;
        };

        var handleParentRoot = function (activeBrandId, brandTree) {

            var parentBrand = {
                id: brandTree.id,
                name: brandTree.name,
                type: brandTree.type
            };

            var activeBrand = brandTree.brands[0]; // In case of active brand is not accessible from user due to access limits

            for (var i in brandTree.brands) {
                if (brandTree.brands[i].id === activeBrandId) {
                    activeBrand = brandTree.brands[i];
                }
            }

            if (!self.levels[parentBrand.type]) {
                self.levels[parentBrand.type] = {};
            }

            if (!self.levels[parentBrand.type][parentBrand.id]) {
                self.levels[parentBrand.type][parentBrand.id] = {};
            }

            self.levels[parentBrand.type][parentBrand.id] = parentBrand;

            var children = {};

            for (var i in brandTree.brands) {
                if (brandTree.brands[i].id === activeBrand.id) {
                    var brands = brandTree.brands[i].brands;

                    delete activeBrand.brands;

                    if (self.isEnterpriseOrChildBrand(activeBrand.type)) {
                        brands = [activeBrand].concat(brands);
                    }

                    children[brandTree.brands[i].id] = {
                        name: brandTree.brands[i].name,
                        id: brandTree.brands[i].id,
                        type: activeBrand.type,
                        brands: brands
                    };

                } else {
                    brandTree.brands[i].type = activeBrand.type; // because the siblings are in the same level.
                    children[brandTree.brands[i].id] = brandTree.brands[i];
                }
            }

            self.levels[parentBrand.type][parentBrand.id].children = children;

            self.activeBrand = {
                parent_id: parentBrand.id,
                parent_type: parentBrand.type,
                brand_id: activeBrand.id,
                brand_type: activeBrand.type,
                brand_name: activeBrand.name
            };
        };

        var handleEntryBrandRoot = function (brandTree) {
            var tree = {
                brands: [brandTree],
                name: "",
                type: "ROOT_PARENT",
                id: -1
            };
            handleParentRoot(brandTree.id, tree);
        };

        var handleActiveBrandRoot = function (brandTree) {

            var activeBrand = brandTree;

            var brands = activeBrand.brands;

            delete activeBrand.brands;


            if (self.isEnterpriseOrChildBrand(activeBrand.type)) {
                brands = [activeBrand].concat(brands);
            }

            self.levels[self.activeBrand.parent_type][self.activeBrand.parent_id].children[activeBrand.id].brands = brands;

            self.activeBrand.brand_id = activeBrand.id;
            self.activeBrand.brand_name = activeBrand.name;
        };

        var toggleExpandJobsForBrand = function (brand) {
            brand.expandJobs = !brand.expandJobs;
        };

        self.canNavigate = function (type) {

            if (!self.activeBrand || self.loading) {
                return false;
            }

            var siblingsBrandsIds = Object.keys(self.levels[self.activeBrand.parent_type][self.activeBrand.parent_id].children);

            switch (type) {

                case self.NAVIGATION_TYPES.ROOT :
                case self.NAVIGATION_TYPES.PARENT :

                    return hasAccessToContext() && self.activeBrand.brand_id !== hUser.getEntryMode().brand_id;

                case self.NAVIGATION_TYPES.LEFT :
                    return siblingsBrandsIds[siblingsBrandsIds.indexOf(self.activeBrand.brand_id.toString()) - 1];

                case self.NAVIGATION_TYPES.RIGHT :

                    return siblingsBrandsIds[siblingsBrandsIds.indexOf(self.activeBrand.brand_id.toString()) + 1];
            }
        };

        var hasAccessToContext = function () {
            if (!hUser.isTopLevelContext()) {
                var brandList = hUser.getUser().brands_list;
                var found = _.find(brandList, {"id": hUser.getUserContext().brand_id});
                return !!found;
            }
            return true;
        };

        var init = function () {

            self.loading = true;
            var brandId = self.brandId;

            expandBrand(brandId, true, true)
                .then(function () {
                    var activeBrand;

                    for (var i in  self.levels[self.activeBrand.parent_type][self.activeBrand.parent_id].children[self.activeBrand.brand_id].brands) {
                        var brand = self.levels[self.activeBrand.parent_type][self.activeBrand.parent_id].children[self.activeBrand.brand_id].brands[i];

                        if (brand && brand.id === self.brandId) {
                            activeBrand = brand;
                        }
                    }

                    if (!activeBrand && self.levels[self.activeBrand.parent_type]) {
                        activeBrand = self.levels[self.activeBrand.parent_type][self.activeBrand.parent_id].children[self.activeBrand.brand_id];
                    }

                    toggleExpandJobsForBrand(activeBrand);

                    self.loading = false;
                });

        };

        self.$onInit = function () {
            init();
        };

    };

})();